import {request} from "./http";

var _basicAuth = null;
var _listeners = [];

function loadFromStorage() {
    try {
        var raw = localStorage.getItem("auth_basic");
        if (!raw) { return null; }
        var obj = JSON.parse(raw);
        if (obj && obj.username && obj.password) { return obj; }
    } catch (e) {}
    return null;
}

function saveToStorage(auth) {
    try {
        if (auth) { localStorage.setItem("auth_basic", JSON.stringify(auth)); }
        else { localStorage.removeItem("auth_basic"); }
    } catch (e) {}
}

export function setBasicAuth(username, password) {
    _basicAuth = { username: username, password: password };
    saveToStorage(_basicAuth);
    notifyAuthChanged();
}

export function clearBasicAuth() {
    _basicAuth = null;
    saveToStorage(null);
    notifyAuthChanged();
}

export function authHeader() {
    if (!_basicAuth) {
        var s = loadFromStorage();
        if (s) { _basicAuth = s; }
    }
    if (!_basicAuth) { return {}; }
    var token = btoa(_basicAuth.username + ":" + _basicAuth.password);
    return { "Authorization": "Basic " + token };
}

export function isLoggedIn() {
    if (_basicAuth) { return true; }
    var s = loadFromStorage();
    if (s) { _basicAuth = s; return true; }
    return false;
}

export function getAuthUser() {
    if (!_basicAuth) {
        var s = loadFromStorage();
        if (s) { _basicAuth = s; }
    }
    return _basicAuth ? _basicAuth.username : null;
}

export function subscribeAuth(listener) {
    if (typeof listener === "function") {
        _listeners.push(listener);
        return function unsubscribe() {
            var i = _listeners.indexOf(listener);
            if (i >= 0) { _listeners.splice(i, 1); }
        };
    }
    return function(){};
}

function notifyAuthChanged() {
    for (var i = 0; i < _listeners.length; i++) {
        try { _listeners[i](); } catch (e) {}
    }
}

export function checkAuth(username, password) {
    var hdr = "Basic " + btoa(username + ":" + password);

    return request("/api/auth/check", {
        method: "GET",
        headers: { Authorization: hdr }
    })
        .then(function () {
            // 204/200 -> OK
            return true;
        })
        .catch(function (err) {
            // request() pri !res.ok hodí Error s .status
            if (err && err.status === 401) { return false; }
            throw err; // iné chyby nech preletia
        });
}

